module.exports = __webpack_public_path__ + "static/media/004-astronaut.b88f7f50.svg";